// src/AppProviders.jsx
import { AuthProvider } from "./context/AuthContext";
import { useBackgroundCleanup } from "./hooks/useBackgroundCleanup";

function GlobalEffects({ children }) {
  useBackgroundCleanup();
  return <>{children}</>;
}

const AppProviders = ({ children }) => {
  return (
    <AuthProvider>
      <GlobalEffects>{children}</GlobalEffects>
    </AuthProvider>
  );
};

export default AppProviders;